import { render, staticRenderFns } from "./discount-code.vue?vue&type=template&id=3d34ecbc&scoped=true"
import script from "./discount-code.vue?vue&type=script&lang=ts"
export * from "./discount-code.vue?vue&type=script&lang=ts"
import style0 from "./discount-code.vue?vue&type=style&index=0&id=3d34ecbc&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d34ecbc",
  null
  
)

export default component.exports